// extracted by mini-css-extract-plugin
export default {"fries":"fries_fries__d3cxx"};